import { request } from "../@utils";
import { requestFile } from "../@utils";
const brandService = {
  createBrand: async (params) => {
    const res = await request.post("/brand/create",{ data: params });
    return res;
  },
  deleteBrand: async (brandId) => {
    const res = await request.post(`/brand/delete/${brandId}`);
    return res;
  },
  disableBrand: async (brandId) => {
    const res = await request.get(`/brand/disable/${brandId}`);
    return res;
  },
  enableBrand: async (brandId) => {
    const res = await request.get(`/brand/enable/${brandId}`);
    return res;
  },
  getBrandPageList: async (params) => {
    const res = await request.post("/brand/page",{ data: params });
    return res;
  },
  updateBrand: async (params) => {
    const res = await request.post('/brand/update',{ data: params })
    return res;
  },
  exportBrand: async (params) => {
    const res = await requestFile.post('/brand/export',{ data: params, responseType: "blob"  })
    return res;
  }
};
export default brandService;